import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import * as z from "zod";
import { zodValidator } from "@tanstack/zod-adapter";
import { MeetingsPage } from "./-components/MeetingsPage";
import {
  PLATFORM_OPTIONS,
  SEVERITY_OPTIONS,
  STATUS_OPTIONS,
} from "./-components/meetings-utils";
import { sharedMeetingsListQueryOptions } from "@/lib/queries/meetings";

const searchSchema = z.object({
  page: z.number().int().positive().default(1).catch(1),
  per_page: z.number().int().positive().max(100).default(10),
  search: z.string().optional(),
  date_filter: z
    .enum(["all", "today", "week", "month", "year", "custom"])
    .optional(),
  date_from: z.string().optional(),
  date_to: z.string().optional(),
  state_group: z.array(z.enum(STATUS_OPTIONS)).default(["All"]).catch(["All"]),
  severity: z.array(z.enum(SEVERITY_OPTIONS)).default(["All"]).catch(["All"]),
  platform: z.array(z.enum(PLATFORM_OPTIONS)).default(["All"]).catch(["All"]),
});

export const Route = createFileRoute("/_app/meetings/shared")({
  component: RouteComponent,
  validateSearch: zodValidator(searchSchema),
  search: {
    middlewares: [
      stripSearchParams({
        search: "",
        state_group: ["All"],
        severity: ["All"],
        platform: ["All"],
      }),
    ],
  },
  loaderDeps: ({ search }) => search,
  loader({ context: { queryClient }, deps }) {
    // Shared meetings are filtered client-side (the endpoint returns the full
    // list), so status filters are not forwarded to the query here.
    queryClient.ensureQueryData(sharedMeetingsListQueryOptions(deps));
  },
});

function RouteComponent() {
  return <MeetingsPage title="Shared with Me" view="shared" />;
}
